import Banner from "./Bannner";
import ContactFooter from "./ContactFooter";
import HtmlRenderer from "./HtmlRenderer";
import { Link } from "react-router-dom";
import glv from '../utils/getLocalizedValue'

function Introduce({ name, position, description, imgSrc }) {
  return (
    <>
      <section className="flex sm:flex-row flex-col justify-center sm:items-start items-center w-full font-pretendard my-10 mb-[8rem]">
        <div className="flex h-full sm:mb-0 mb-5 w-[10rem]">
          <img alt="" src={imgSrc} className="w-full object-cover" />
        </div>
        <div className="flex flex-1 flex-col sm:ms-[3rem] flex-wrap mb-5">
          <header className="mb-5 pb-5 border-b-[1px] border-brand-steel-grey">
            <h2 className="me-5">
              <span className="font-[900] f-32">{name && name}</span>
              &nbsp;
              &nbsp;
              <br className="sm:hidden"/>
              <span className="font-[700] f-20 leading-8 text-brand-kool-blue">
                {position && position}
              </span>
            </h2>
          </header>
          <section className="font-[300] f-20 leading-8 tracking-[-0.015em] text-justify text-[#5F5D59]">
            <HtmlRenderer htmlString={description} />
          </section>
        </div>
      </section>
    </>
  );
}

function Section({ title, summary, content, link, src }) {
  return (
    <>
      <section className="flex flex-wrap justify-center items-center w-full font-pretendard py-[5rem]">
        <header className="text-center mb-10">
          <h2 className="font-[900] f-32">{title && title}</h2>
          <br />
          <span className="font-[700] f-20 leading-8 text-brand-kool-blue">
            {summary && summary}
          </span>
        </header>
        <section className="font-[300] f-20 leading-8 tracking-[-0.015em] mb-10 text-justify">
          <HtmlRenderer htmlString={content} />
        </section>
        {link && (
          <footer className="font-[700] f-20">
            <Link to={src && src}>
              <span className="underline">{link && link}</span> ➜
            </Link>
          </footer>
        )}
      </section>
    </>
  );
}

function CompanyPage() {
    return (
      <>
        <div className="w-full h-full overflow-y-scroll overflow-x-hidden">
          <Banner
            title={glv("About KoolMicro","KoolMicro 소개")}
            src={require("../assets/about-banner-bg.jpg")}
          />
          
          <div className="max-w-[70rem] mx-auto px-5 mt-10">
            <Section
              title={glv("Company Introduction","머릿글")}
              summary={"“We make your tomorrow Kool-er.”"}
              content={
                glv("KoolMicro is synonymous with ultimate cooling solutions for microelectronics, delivering innovative technologies designed to meet the demands of next-generation devices. As pioneers in integrating advanced cooling solutions with heterogeneous semiconductor packaging for AI applications, we set the standard for performance and reliability.<br/><br/>Our patented Integrated Manifold MicroChannel technology represents a breakthrough in addressing the thermal and mechanical challenges of cutting-edge semiconductor devices, ensuring optimal efficiency and longevity.<br/><br/>We specialize in custom-tailored cooling solutions for high-performance semiconductors across data centers, automotive systems, and telecommunications, making KoolMicro your trusted partner for advanced thermal management."
                  ,"KoolMicro는 Microelecronics 분야에서 맞춤형 냉각 솔루션 산업의 대표주자로, 차세대 디바이스의 요구를 충족시키기 위해 설계된 혁신적인 기술을 선보입니다. <br/>AI 애플리케이션을 위한 첨단 냉각 솔루션과 이종 반도체 패키징을 통합하는 데 있어 성능과 신뢰성의 기준을 선도하고 있습니다.<br/><br/>KoolMicro의 특허 기술인 IMMC(Integrated Manifold MicroChannel) 기술은 첨단 반도체 장치의 열적·기계적 과제를 해결하는 획기적인 돌파구를 제공하며, 운영 장비 및 칩셋이 최적의 효율성과 장기적인 안정성을 가질수 있도록 보장합니다.<br/><br/>KoolMicro는 첨단 열관리 분야에서 신뢰할 수 있는 파트너로서 데이터센터, 자동차 시스템, 통신 분야 등 필요한 곳 어디든 고성능 반도체를 위한 맞춤형 냉각 솔루션을 전문으로 제공합니다.")}
              link={glv("Click Here for our Latest News and Updates","KoolMicro의 최신 뉴스 및 동향 보러가기")}
              src={"/company/news"}
            />
            <Section
              title={glv("You are in Good Hands","믿고 맡길 수 있는 KoolMicro")}
              summary={glv("Meet the team behind all the magic at KoolMicro","KoolMicro의 모든 혁신을 이끄는 전문가 팀을 소개합니다.")}
              content={
                glv("At KoolMicro, we bring over 25 years of expertise in semiconductor chip architecture and packaging. Our deep understanding of the industry’s challenges allows us to deliver powerful, innovative solutions that exceed expectations. With a team of experts driven by passion and precision, we are committed to providing our customers with the confidence and results they need to succeed in the fast-evolving tech landscape."
                  ,"KoolMicro는 25년 이상의 반도체 칩 아키텍처와 패키징 경험을 바탕으로, 업계의 가장 까다로운 과제를 해결합니다. <br/>깊은 기술 이해와 혁신적 솔루션을 통해 고객이 기대하는 그 이상을 제공합니다. <br/>열정과 실력으로 업계 최고의 기술 발전을 이끄는 전문가 팀이 빠르게 변하는 기술 환경 속에서 고객의 확신과 성과를 보장합니다.")
              }
            />
          </div>

          <div className="max-w-[70rem] mx-auto px-5 mt-10">
            <Introduce
              imgSrc={require("../assets/photo/1.png")}
              name={glv("Yunheok Im","임윤혁")}
              position={"CEO"}
              description={
                glv("<strong class='text-black'>Yunhyeok Im</strong> has over 24 years of experience in thermal engineering for semiconductor chips and components, working at Samsung Electronics and Georgia Tech. He has led thermal analysis and design projects for SOC, RF, image sensors, and memory products from early development stages.<br/><br/>Dr. Im holds 54 U.S. patents and has published over 30 papers in the field. His current research focuses on next-generation liquid cooling and advanced thermal architectures for semiconductor packages. He earned his Ph.D. in Mechanical Engineering from KAIST."
                  ,"<strong class='text-black'>임윤혁</strong> CEO는 삼성전자와 조지아 공과대학교 소속으로 반도체 칩 및 관련 부품의 열 엔지니어링 분야에서 24년 이상의 경력을 쌓았으며, SOC, RF, 이미지 센서, 메모리 제품의 초기 개발 단계부터 열 해석 및 설계 프로젝트를 주도해왔습니다.<br/><br/>54건의 미국 특허와 30편 이상의 논문을 보유하고 있는 임윤혁 CEO는 KAIST에서 기계공학 박사 학위를 취득했으며, 현재 차세대 액체 냉각 및 첨단 반도체 패키지를 위한 열 아키텍처 연구에 집중하고 있습니다. ")
              }
            />
            <Introduce
              imgSrc={require("../assets/photo/2.png")}
              name={glv("Wonyoung Maeng","맹원영")}
              position={"CSO"}
              description={
                glv("<strong class='text-black'>Wonyoung Maeng</strong> has nearly 20 years of experience in strategy, business, and technology planning within the semiconductor industry. At Samsung Electronics, he managed the Samsung Strategy Innovation Center and the Catalyst Fund in Silicon Valley, leading initiatives in M&A, divestitures, equity investments, and partnerships.<br/><br/>He currently leads strategy and operations at KoolMicro, focusing on business growth through market analysis and competitive intelligence. He holds a degree in Management Engineering from KAIST and Industrial Engineering from Korea University."
                  ,"<strong class='text-black'>맹원영</strong> CSO는 반도체 산업에서 전략, 사업 및 기술 기획 분야에서 20년 가까운 경력을 보유하고 있습니다. 삼성전자에서 실리콘밸리의 삼성전략혁신센터와 Catalyst Fund를 관리하며 M&A, 사업 매각, 지분 투자 및 파트너십을 주도했습니다.<br/><br/>현재는 Koolmicro에서 전략 및 운영을 총괄하며, 시장 분석과 경쟁 인텔리전스를 기반으로 사업 성장을 이끌고 있습니다. KAIST에서 경영공학을, 고려대학교에서 산업공학을 전공했습니다.")}
            />
            <Introduce
              imgSrc={require("../assets/photo/3.png")}
              name={"Michael Helms"}
              position={"Advisor"}
              description={
                glv("<strong class='text-black'>Dr. Michael Helms</strong> is a Senior Research Scientist at the Georgia Institute of Technology, Co-Director of the Center for Biologically Inspired Design at Georgia Tech and Founder of PatternFox Consulting. He earned his Ph.D. in Computer Science from the Georgia Institute of Technology. <br/><br/>Dr. Helms' recent work focuses on understanding apply design methods in industrial and educational settings to increase design innovation, improve sustainability and better manage uncertainty. He has over 70 peer-reviewed publications in the field of design.  Prior to his research career, Dr. Helms was an industry consultant with Teradata, with expertise in finance, data science and B2B technology sales."
                  ,"<strong class='text-black'>Michael Helms</strong> 박사는 조지아 공과대학교에서 컴퓨터 과학 박사 학위를 취득한 뒤 생체모방 디자인 센터의 선임 연구원이자 공동 디렉터로 재직 중이시며, PatternFox Consulting의 창립자입니다.<br/><br/>Helms 박사는 디자인 분야에서 70편 이상의 논문을 발표했으며, 연구 경력 이전에는 Teradata에서 컨설턴트로 활동하며 금융, 데이터 과학, B2B 기술 영업 분야의 전문성을 쌓았습니다. 현재는 Koolmicro의 어드바이저로서 기업 성장을 지원하는 동시에, 산업 및 교육 현장에서 디자인 방법론을 적용하여 혁신 증대, 지속가능성 개선, 불확실성 관리에 대한 연구를 주로 진행하고 있습니다.")
                }
            />
          </div>

          <div className="flex flex-col w-full text-center my-[10rem] sm:scale-100 scale-75">
            {glv(<div>
              <span className="font-pretendard font-[900] f-32">
                Feeling included?
                <br className="sm:hidden" /> Come join the world’s{" "}
                <span className="text-brand-electric-blue">Kool-est</span>{" "}
                family!
              </span>
            </div>,"")}
            <div className="mt-10 bg-brand-electric-blue rounded-full py-3 px-[4rem] w-fit mx-auto">
              <Link to="/career" className="">
                <span className="underline font-[700] f-20">
                  {glv("Click Here to check our Open Positions & Offers","KoolMicro의 채용 공고 및 지원 확인하기")}
                </span>{" "}
                ➜
              </Link>
            </div>
          </div>
          <ContactFooter />
        </div>
      </>
    );
}

export default CompanyPage;
